import React, { Fragment, Suspense } from 'react';
import { AppContextType } from '@embed/components/helpers';
import { useEmbedAppContext, } from '@embed/hooks/useEmbedAppContext';
import { useEmbedFeed } from '@embed/hooks/useEmbedFeed';
const VideoPlayer = React.lazy(() => import('@embed/components/VideoPlayer'));
const PlaylistVideoPlayerWithContext = (props) => {
    const { actions, appContext, muted, params } = props;
    const [{ videos }, feedActions] = useEmbedFeed({
        config: appContext.embedFeedConfig,
        guestId: appContext.guestId,
        params,
        performance: appContext === null || appContext === void 0 ? void 0 : appContext.performance,
    });
    return videos[0] ? (<Suspense fallback={<Fragment />}>
      <VideoPlayer actions={actions} appContext={appContext} onClose={actions.hideVideoPlayer} params={params} videos={videos} video={videos[0]} muted={muted} triggerFetchNextVideos={feedActions.loadMore}/>
    </Suspense>) : null;
};
export const PlaylistVideoPlayer = (props) => {
    const { actions, params, playlist } = props;
    const playlistParams = Object.assign(Object.assign({}, params), { playlist: playlist.id });
    const appContext = useEmbedAppContext({
        params: playlistParams,
        actions,
        appContextType: AppContextType.WIDGET_CONTEXT_TYPE,
    });
    return appContext ? (<PlaylistVideoPlayerWithContext {...props} appContext={appContext} params={playlistParams}/>) : null;
};
